<template>
  <div class="cotton-right-button-wrap">
    <div
      class="cotton-right-button_item"
      :class="{ 'is-active': isActive(btn) }"
      v-for="btn in btns"
      :key="btn.text"
      @click="toggle(btn)"
    >
      <img :src="btn.icon" :alt="btn.text" />
      <span>{{ btn.text }}</span>
    </div>
  </div>
</template>

<script>
import realTimeImg from '@/assets/image/components/dark-real.png';
import lightReal from '@/assets/image/components/light-real.png';

import historyImg from '@/assets/image/components/dark-history.png';
import lightHis from '@/assets/image/components/light-history.png';

import warinImg from '@/assets/image/components/dark-warin.png';
import lightWarin from '@/assets/image/components/light-warin.png';

import taskImg from '@/assets/image/components/dark-task.png';
import lightTaskImg from '@/assets/image/components/light-task.png';

// import reportImg from '@/assets/image/components/dark-report.png';
// import lightReport from '@/assets/image/components/light-report.png';
// import CuttonImg from '@/assets/image/components/cotton-button.png';
import { mapState } from 'vuex';

export default {
  props: {
    currentRoute: String
  },
  computed: {
    ...mapState('app', ['theme'])
  },
  data() {
    return {
      btns: [
        { text: this.$t('实时'), icon: realTimeImg, key: 'drone-real-data' },
        { text: this.$t('历史'), icon: historyImg, key: 'drone-history-data' },
        { text: this.$t('报警'), icon: warinImg, key: 'drone-alarm-data' },
        { text: this.$t('任务列表'), icon: taskImg, key: 'drone-task-data' }
      ]
    };
  },
  watch: {
    theme(e) {
      if (e) {
        if (e == 'light') {
          this.btns = [
            { text: this.$t('实时'), icon: lightReal, key: 'drone-real-data' },
            { text: this.$t('历史'), icon: lightHis, key: 'drone-history-data' },
            { text: this.$t('报警'), icon: lightWarin, key: 'drone-alarm-data' },
            { text: this.$t('任务列表'), icon: lightTaskImg, key: 'drone-task-data' }
          ];
        } else {
          this.btns = [
            { text: this.$t('实时'), icon: realTimeImg, key: 'drone-real-data' },
            { text: this.$t('历史'), icon: historyImg, key: 'drone-history-data' },
            { text: this.$t('报警'), icon: warinImg, key: 'drone-alarm-data' },
            { text: this.$t('任务列表'), icon: taskImg, key: 'drone-task-data' }
          ];
        }
      }
    }
  },

  methods: {
    isActive(val) {
      return this.currentRoute === val.key;
    },

    toggle(val) {
      this.$emit('toggle', val);
    }
  }
};
</script>

<style lang="scss">
.cotton-right-button-wrap {
  border: 2px solid #047eba;
  border-radius: 110px;
  backdrop-filter: blur(4px);

  box-sizing: border-box;

  width: 90px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 15px;

  padding: 20px 10px;

  position: absolute;
  right: 15px;
  bottom: 20px;
  z-index: 7;

  .cotton-right-button_item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    width: 100%;

    cursor: pointer;

    transition: all 0.3s;

    &.is-active {
      filter: brightness(1.5);
      scale: 1.1;

      span {
        font-weight: 600;
        color: #318eff;
      }
    }

    &:hover {
      filter: brightness(1.5);
    }

    img {
      width: 130%;
    }

    span {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 16px;
      color: var(--drone-list-base-font-color);
      line-height: 23px;

      transition: all 0.3s;
    }
  }
}
</style>
